import React from "react";
import { KTSVG } from "../../helpers/KTSVG";
import Text from "../../styleguide/Text";
import {
  getSemanticIconClasses,
  getSemanticSubtleBackgroundClasses,
  getSemanticTextClasses,
} from "../../theme/semanticClasses";

export interface CustomItemPress {
  id: number | string;
  label: string | number;
  [key: string]: any;
}

function CustomListItem({
  backgroundColor = "info",
  item,
  description,
  infoText,
  withIcon,
  iconName = "/media/icons/duotune/medicine/med002.svg",
  iconColor = "success",
  onClick,
  containerStyle,
}: {
  backgroundColor?: "info" | "success" | "warning" | "danger" | "primary";
  item: CustomItemPress;
  description?: string;
  infoText?: {
    text: string;
    color?: "info" | "success" | "warning" | "danger" | "primary";
  };
  withIcon?: boolean;
  iconName?: string;
  iconColor?: string;
  onClick?: (value: CustomItemPress) => void;
  containerStyle?: React.CSSProperties;
}) {
  const handleOnItemClick = (e: any) => {
    e.preventDefault();
    onClick && onClick(item);
  };

  return (
    <button
      type="button"
      className={`group mb-4 flex w-full items-center justify-between rounded-control border-0 p-4 text-left transition-colors hover:brightness-[0.98] focus:outline-none focus:ring-2 focus:ring-[#2196f3]/20 ${getSemanticSubtleBackgroundClasses(
        backgroundColor,
      )}`}
      style={containerStyle}
      onClick={handleOnItemClick}>
      <div className="flex min-w-0 items-center text-left">
        {withIcon && (
          <KTSVG
            path={iconName}
            className={`mr-5 shrink-0 ${getSemanticIconClasses(iconColor)}`}
            svgClassName="h-6 w-6"
          />
        )}
        <div className="mr-2 min-w-0">
          {item.label && (
            <Text className="font-semibold text-slate-800">{item.label}</Text>
          )}
          {description && (
            <Text variant="body1" className="font-medium text-muted">
              {description}
            </Text>
          )}
        </div>
      </div>
      {infoText?.text && (
        <Text
          variant="body1"
          className={`shrink-0 py-1 font-semibold ${getSemanticTextClasses(
            infoText.color ?? "success",
          )}`}>
          {infoText.text}
        </Text>
      )}
    </button>
  );
}

export default CustomListItem;
